/**
 * Created by pajicv on 9/25/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  button: {
    bottom: 50,
    left: '50%',
    position: 'absolute',
    width: 100,
    height: 100,
    transform: 'translate(-50%, 0%)',
    zIndex: 1000
  },
  label: {
    bottom: 5,
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%, 0%)',
    zIndex: 1000,
    fontSize: 18,
    fontWeight: 'bold'
  }
});

const CreateProjectButton = ({ classes, onClick, title }) => (
  <React.Fragment>
    <Button
      variant="fab"
      color="primary"
      aria-label="Add"
      className={classes.button}
      onClick={onClick}
    >
      <AddIcon />
    </Button>
    <Typography className={classes.label}>{title}</Typography>
  </React.Fragment>
);

CreateProjectButton.propTypes = {
  classes: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(CreateProjectButton);



// WEBPACK FOOTER //
// ./src/components/common/AddDocumentButton.js